import { render, staticRenderFns } from "./msgBoxConfirm.vue?vue&type=template&id=2682226f&"
import script from "./msgBoxConfirm.vue?vue&type=script&lang=js&"
export * from "./msgBoxConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports